import React, { useEffect } from 'react';
import { httpRequest } from '../httpRequest';

export default function NewSession(props) {

  useEffect(() => {
    httpRequest.get('SSO/LogOut').finally(() => {
      if (process.env.REACT_APP_IS_DEV_ENVIRONMENT === "true") {
        console.log('Session was reset');
      }
      if (props.setUser) {
        props.setUser();
      }
      sessionStorage.clear();
      var url = props.isSessionTimeout ? '/SessionTimeOut' : process.env.REACT_APP_LOGOUT_URL ? process.env.REACT_APP_LOGOUT_URL : '/';
      window.location.href = url;
    });
  }, []);


  return (
    <div />
  )
}


// WEBPACK FOOTER //
// ./src/components/NewSession.js